import {
  MEMBER_STATUS_APPROVED_OPTIONS,
  MEMBER_STATUS_OPTIONS,
  PROCESS_TYPE,
  PROJECT_ROLE,
  PROJECT_STATUS,
  PROJECT_STATUS_OPTIONS,
  PROJECT_STATUS_TEXT,
} from "@helpers/ConstantHelper.js"

export function findProcess(processes, processId) {
  if (!processes?.length) return null

  for (const process of processes) {
    if (Number(process.id) === Number(processId)) {
      return process
    }
    if (Array.isArray(process.children) && process.children.length > 0) {
      const found = findProcess(process.children, processId)
      if (found) return found
    }
  }

  return null
}

export function findFirstActionProcess(processes) {
  if (!processes?.length) return null

  for (const process of processes) {
    if (Number(process.type) === PROCESS_TYPE.ACTION) {
      return process
    }
    if (Array.isArray(process.children) && process.children.length > 0) {
      const found = findFirstActionProcess(process.children)
      if (found) return found
    }
  }

  return null
}

const STATUS_TEXTS = {
  [PROJECT_STATUS.PROJECT_WAIT]: PROJECT_STATUS_TEXT.PROJECT_WAIT,
  [PROJECT_STATUS.PROJECT_NOT_VALID]: PROJECT_STATUS_TEXT.PROJECT_NOT_VALID,
  [PROJECT_STATUS.PROJECT_APPROVE_WAIT]: PROJECT_STATUS_TEXT.PROJECT_APPROVE_WAIT,
  [PROJECT_STATUS.PROJECT_PLAN]: PROJECT_STATUS_TEXT.PROJECT_PLAN,
  [PROJECT_STATUS.PROJECT_NOT_APPROVE]: PROJECT_STATUS_TEXT.PROJECT_NOT_APPROVE,
  [PROJECT_STATUS.PROJECT_IN_PROGRESS]: PROJECT_STATUS_TEXT.PROJECT_IN_PROGRESS,
  [PROJECT_STATUS.PROJECT_WAIT_REVIEW]: PROJECT_STATUS_TEXT.PROJECT_WAIT_REVIEW,
  [PROJECT_STATUS.PROJECT_COMPLETE]: PROJECT_STATUS_TEXT.PROJECT_COMPLETE,
  [PROJECT_STATUS.PROJECT_CANCEL]: PROJECT_STATUS_TEXT.PROJECT_CANCEL,
  [PROJECT_STATUS.PROJECT_COMPLETED_WITH_QR]: PROJECT_STATUS_TEXT.PROJECT_COMPLETED_WITH_QR,
}

export function projectStatusToText(status) {
  return STATUS_TEXTS[status] ?? null
}

export function projectStatusToColor(status) {
  return STATUS_TEXTS[status] ?? null
}

// Color project by status
export const PROJECT_STATUS_COLORS = PROJECT_STATUS_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.color

  return acc
}, {})

export const getProjectStatusColor = status => {
  return PROJECT_STATUS_COLORS[status] || "default"
}

export function getMemberStatusOptions(memberType) {
  return memberType === PROJECT_ROLE.RISK_LEVEL1
  || memberType === PROJECT_ROLE.RISK_LEVEL2
    ? MEMBER_STATUS_APPROVED_OPTIONS
    : MEMBER_STATUS_OPTIONS
}
